// extracted by mini-css-extract-plugin
export default {"Row":"Row_Row__Jcrww"};